import { Component, OnInit, ViewChild, ElementRef }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IScenario, ScenarioService, CreateScenarioRequest, CreateScenarioResponse } from './scenario.service';
import { AirportService } from '../airports/airport.service';
import { QueryReportService } from '../query-reports/query-report.service';
import { IQueryReportResponse, IQueryReportsFacilityRequest } from '../query-reports/query-report'
import { FacilitySearchRequest } from '../airports/facility-search-request';
import { CommonDataService, KeyValuePair, VariableInfo } from '../common-data/commondata.service';
import { UserSession } from '../shared/user-session';
import { Dialog } from 'primeng/primeng';
import {Messages} from 'primeng/primeng';

@Component({
    template: require('./scenario-select-facilities.component.html'),
    styles: [require('../styles/faa_styles.css'),require('./scenario-select-facilities.component.css') ],
    providers: [FacilitySearchRequest, KeyValuePair],
    directives: [ROUTER_DIRECTIVES],
})

export class ScenarioSelectFacilitiesComponent implements OnInit {
    pageTitle: string = 'Select Scenario Facilities';
    errorMessage: string;
    msgs: Messages[]=[];
    currentScenario: IScenario;
    sourceScenario: IScenario;
    sourceLocIds: string[];
    regions: KeyValuePair[];
    states: KeyValuePair[];
    hubSizes: KeyValuePair[];
    facLevels: KeyValuePair[];
    emdfCodes: KeyValuePair[];
    centerids: string[];
    autoCompleteQuery: string = '';
    autoCompleteFilteredList: string[] = [];
    relieverLocIds: string[];
    approachControlIds: string[];
    variables: VariableInfo[];
    enplanementYears: number[];
    moreSearchOptionsVisible: boolean = false;
    moreSearchOptionsControlCssClass: string = 'glyphicon glyphicon-chevron-right';
    moreSearchOptionsItemsCssClass: string = 'hidden';
    thisYear: number;
    showLocids:boolean=false;
    selectedLocids:string;
    requestLocid: IQueryReportsFacilityRequest;
    displaySpinner :boolean=false;


    constructor(private route: ActivatedRoute,
        private router: Router,
        private request: CreateScenarioRequest,
        private searchRequest: FacilitySearchRequest,
        private _scenarioService: ScenarioService,
        private _queryReportService: QueryReportService, 
        private _airportService: AirportService,
        private _commonDataService: CommonDataService,
        private _User: UserSession
    ) { }

    ngOnInit(): void {
        this.thisYear = new Date().getFullYear();

        if (typeof (this._User.scenarioId) === 'undefined')
            this.router.navigate(['./scenario-activities']);

        this.request = this.request.getSession();

        // Retrieve current scenario to set the current selected scenario name
        this._scenarioService.getScenario(this._User.scenarioId)
            .subscribe(
            scenario => this.currentScenario = scenario,
            error => this.errorMessage = <any>error
            );

        // Retrieve locids from the source scenario for autocomplete
        this._airportService.getAirportLocIds(this.request.baseScenarioId)
            .subscribe(
            locIds => this.sourceLocIds = locIds,
            error => this.errorMessage = <any>error
            );

        // Retrieve source scenario so we can set the name
        this._scenarioService.getScenario(this.request.baseScenarioId)
            .subscribe(
            scenario => this.sourceScenario = scenario,
            error => this.errorMessage = <any>error
            );

        // Retrieve data for center ids
        this._airportService.getAirportCenterIds(this.request.baseScenarioId)
            .subscribe(
            centerIds => this.centerids = centerIds,
            error => this.errorMessage = <any>error
            );

        // Retrieve data for Reliever locIds
        this._airportService.getRelieverLocIds(this.request.baseScenarioId)
            .subscribe(
            locIds => this.relieverLocIds = locIds,
            error => this.errorMessage = <any>error
            );

        // Retrieve data for Approach Control ids
        this._airportService.getApproachControlIds(this.request.baseScenarioId)
            .subscribe(
            ids => this.approachControlIds = ids,
            error => this.errorMessage = <any>error
            );

        // Retrieve the Variable Info
        this._commonDataService.getVariableInfo()
            .subscribe(
            info => this.variables = info,
            error => this.errorMessage = <any>error
            );

        // Retrieve Enplanement Years
        this._commonDataService.getEnplanementYears()
            .subscribe(
            years => this.enplanementYears = years,
            error => this.errorMessage = <any>error
            );

        var dropDownItems: string[] = ['region', 'state', 'hubsize', 'faclevel', 'emdfcode'];
        for (let x: number = 0; x < dropDownItems.length; x++) {
            this.populateDropdownData(dropDownItems[x]);
        }

        // Init the search 
        this.searchRequest.baseScenarioId = this.request.baseScenarioId;
        this.requestLocid=new IQueryReportsFacilityRequest([''],1);
    }
    loadLocids(){
        this.showLocids=true;
    }
    saveLocids(){
       
        var charExp = /[^a-zA-Z0-9]+/;
        let nonAlpha = ( this.selectedLocids.replace (/[\t\n\s\r]{1,}/g,"")).match(charExp);
        if(nonAlpha != null){
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Please check the list of LOCID.\nIt can only contain digits[0-9] and alphabets[a-z].' });
            return;
        }
        let selectedLocidsArr  = this.selectedLocids.replace (/[\t\n\s\r]{1,}/g,",").split(",");
        let bError = false;
        for(var i=0; i<=selectedLocidsArr.length-1; i++){
            
            if((selectedLocidsArr[i])!=null){
                if((selectedLocidsArr[i].length>4) || (selectedLocidsArr[i].length <3)){
                        bError=true;
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'The LOCID length can be only 3 or 4 characters.' });
                        return;
                }
            }
        }
        this.requestLocid.locid=selectedLocidsArr;
        this.requestLocid.scenarioId = this.currentScenario.id;
        this._queryReportService.saveLocids(this.requestLocid)
                .subscribe(
                    response => {
                        if(response.responseMessage ==="No Match"){
                            this.msgs=[];
                            this.msgs.push({severity:'error', summary:'Error Message', detail: 'Following Locid list is not part of your selected scenario '
                                            + response.locidNoMatch + '. Please remove from list before continuing.'});
                        }
                        if(response.savedLocidList != null)
                        {
                            this.request.facilities = response.savedLocidList;
                            this.showLocids = false;
                            this.selectedLocids='';
                            this.msgs=[];
                            //console.log("locidResponse.savedLocidList: "+response.savedLocidList.length);
                            //console.log("locidResponse.responseStatus: "+response.responseStatus);
                        }
                    },
                    error => {
                        this.msgs=[];
                        this.msgs.push({severity:'error', summary:'Error Message', detail: 'An error occured while processing your request.' });
                        this.showLocids = false;
                    },
                    () => {}
                );
    }
    cancelLocids(){
        this.showLocids = false;
        this.selectedLocids='';
    }
    search(): void {
        this._airportService.getAirportLocIdsByCriteria(this.searchRequest)
            .subscribe(
            (results: string[]) => {

                if (results.length === 0) {
                    this.msgs=[];
                    this.msgs.push({severity:'error', summary:'Error Message', detail: 'No facility found matching your criteria.' });
                    return;
                }

                // Don't add to list if already there
                for (let x = 0; x < results.length; x++) {
                    if (this.request.facilities.indexOf(results[x]) === -1) {
                        this.request.facilities.push(results[x]);
                    }
                }

                this.request.updateSessionState();
            },
            error => this.errorMessage = <any>error
            );
    }

    moreSearchOptionsClick(): void {
        if (!this.moreSearchOptionsVisible) {
            this.moreSearchOptionsVisible = true;
            this.moreSearchOptionsItemsCssClass = 'more-search-options';
            this.moreSearchOptionsControlCssClass = this.moreSearchOptionsControlCssClass.replace('right', 'down');

            // Set the defaults for the request
            this.searchRequest.searchOption = "growth";
            if (typeof (this.searchRequest.selectVariable) === 'undefined') 
                this.searchRequest.selectVariable = this.variables[0].searchVariable;
            if (typeof (this.searchRequest.growthStartYear) === 'undefined')
                this.searchRequest.growthStartYear = new Date().getFullYear();
            if (typeof (this.searchRequest.growthEndYear) === 'undefined')
                this.searchRequest.growthEndYear = new Date().getFullYear();
            if (typeof (this.searchRequest.growthOperator) === 'undefined')
                this.searchRequest.growthOperator = "less";
            if (typeof (this.searchRequest.growthPercentage) === 'undefined')
                this.searchRequest.growthPercentage = 0.00;
            if (typeof (this.searchRequest.growthExcludeChanges) === 'undefined')
                this.searchRequest.growthExcludeChanges = false;

        } else {
            this.moreSearchOptionsVisible = false;
            this.moreSearchOptionsItemsCssClass = 'hidden';
            this.moreSearchOptionsControlCssClass = this.moreSearchOptionsControlCssClass.replace('down', 'right');

            // Reset the request searchOptioin
            this.searchRequest.searchOption = null;
        }

        console.log(this.searchRequest);
    }

    createScenario(): void {
        this.displaySpinner = true;
        if (this.request.facilities.length === 0) {
            let msg: string = `Please select a list of Facilities before creating the scenario.
Select your search criteria and then click the 'Search' button to populate the scenario facilities list.`;
            this.msgs=[];
            this.msgs.push({severity:'error', summary:'Error Message', detail: msg });
            this.displaySpinner = false;
            //alert(msg);
            return;
        }

        this._scenarioService.createScenario(this.request)
            .subscribe(
            (response: CreateScenarioResponse) => {
                if (response.responseStatus === 'ERROR') {
                    this.msgs=[];
                    this.msgs.push({severity:'error', summary:'Error Message', detail: response.responseMessage });
                    //alert(response.responseMessage);
                    this.displaySpinner = false;
                    return;
                }
                this.router.navigate(['./scenario-create-results']);
            },
            error => this.errorMessage = <any>error
            );
    }

    removeFacilityFromList(locid: string): void {
        let index: number = this.request.facilities.indexOf(locid);
        this.request.facilities.splice(index, 1);
        this.request.updateSessionState();
    }

    clearAllFacilities(): void {
        this.request.facilities = [];
        this.request.updateSessionState();
    }

    cancel(): void {
        this.request.destroySession();
        this.router.navigate(['./scenario-activities']);
    }

    onSelect(event: Event, element: string) {
        let select: HTMLSelectElement = event.target as HTMLSelectElement;
        switch (element) {
            case 'region':
                this.searchRequest.region = select.value !== 'All' ? select.value : '';
                break;
            case 'state':
                this.searchRequest.state = select.value !== 'All' ? select.value : '';
                break;
            case 'hubSize':
                this.searchRequest.hubSize = select.value !== 'All' ? +select.value : -1;
                break;
            case 'level':
                this.searchRequest.level = select.value !== 'All' ? +select.value : -1;
                break;
            case 'emdfCode':
                this.searchRequest.type = select.value !== 'All' ? +select.value : -1;
                break;
            case 'centerAreaId':
                this.searchRequest.centerId = select.value !== 'All' ? +select.value : -1;
                break;
            case 'selectVarible':
                this.searchRequest.selectVariable = select.value;
                break;
            case 'growthStartYear':
                this.searchRequest.growthStartYear = +select.value;
                break;
            case 'growthEndYear':
                this.searchRequest.growthEndYear = +select.value;
                break;
            case 'valueYear':
                this.searchRequest.varValueYear = +select.value;
                break;
        }
    }

    onInput(event: Event, element: string){
        let input:HTMLInputElement = event.target as HTMLInputElement;
        "test this";
        if(isNaN(+input.value)){
           this.msgs=[];
           this.msgs.push({severity:'error', summary:'Error Message', detail:'Please enter a decimal value for the growth rate' });
           // alert('Please enter a decimal value for the growth rate');
            input.value = '';
            return;
        }
        if(element === 'growth')
            this.searchRequest.growthPercentage = +input.value;
        if(element === 'varvalue')
            this.searchRequest.varValue = +input.value;
    }

    onMoreSelectOption(event: Event, element: string) {
        if (element === 'growth') {
            this.searchRequest.searchOption = 'growth';
        }
        if (element === 'varvalue') {
            this.searchRequest.searchOption = 'varvalue';
            if (typeof (this.searchRequest.varValueYear) === 'undefined')
                this.searchRequest.varValueYear = new Date().getFullYear();
            if (typeof (this.searchRequest.varValueOperator) === 'undefined')
                this.searchRequest.varValueOperator = 'less';
            if (typeof (this.searchRequest.varValue) === 'undefined')
                this.searchRequest.varValue = 0;
        }
    }

    onOperatorSelectOption(event: Event, element: string, value: string){
        if(element === 'growth'){
            this.searchRequest.growthOperator = value;
        }
        if(element === 'varvalue'){
            this.searchRequest.varValueOperator = value;
        }
    }

    onCheck(event: Event, element: string) {
        let checkbox: HTMLInputElement = event.target as HTMLInputElement;
        switch (element) {
            case 'allFaaTowers':
                this.searchRequest.allFaaTowers = checkbox.checked;
                break;
            case 'allFaaAndContractTowers':
                this.searchRequest.allFaaContractTowers = checkbox.checked;
                break;
            case 'oeps35':
                this.searchRequest.oep35 = checkbox.checked;
                break;
            case 'growthExcludeChanges':
                this.searchRequest.growthExcludeChanges = checkbox.checked;
                break;
        }
    }

    autoCompleteFilter(): void {
        this.searchRequest.locId = this.autoCompleteQuery.trim();
        if (this.autoCompleteQuery.trim().length > 0) {
            this.autoCompleteFilteredList = this.sourceLocIds.filter(function (el: any) {
                return el.toUpperCase().indexOf(this.autoCompleteQuery.toUpperCase()) > -1;
            }.bind(this));
        }
    }

    autoCompleteSelect(item: string) {
        this.autoCompleteQuery = item;
        this.autoCompleteFilteredList = [];
        this.searchRequest.locId = item;
    }

    private populateDropdownData(source: string): void {
        this._commonDataService.getData(source)
            .subscribe(
            (list: KeyValuePair[]) => {
                switch (source) {
                    case 'region':
                        this.regions = list;
                        break;
                    case 'state':
                        this.states = list;
                        break;
                    case 'hubsize':
                        this.hubSizes = list;
                        break;
                    case 'faclevel':
                        this.facLevels = list;
                        break;
                    case 'emdfcode':
                        this.emdfCodes = list;
                        break;
                }
            },
            error => this.errorMessage = <any>error
            );
    }
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-select-facilities.component.ts
 **/